import SimpleLightbox from "simplelightbox";

export const runSimpleLightbox = () => {
  const galleries = document.querySelectorAll('.pw-lightbox');
  const index = 0;
  let galleriesClasses = [];

  if(!galleries) 
    return;

  galleries.forEach(function(gallery){
    const className = 'pw-lightbox-' + index;
    gallery.classList.add(className);
    galleriesClasses.push(className);
    index++;
  });

  galleriesClasses.forEach(function(galleryClass){
    new SimpleLightbox('.' + galleryClass + ' a', {
      showCounter: false,
      captions: false,
      fadeSpeed: 100,
      animationSlide: false,
      navText: ['<div class="pw-sl-arrow pw-sl-arrow--prev"></div>', '<div class="pw-sl-arrow pw-sl-arrow--next"></div>'],
    });
  });
}
